module.exports = __webpack_public_path__ + "img/img_82837_0_20.6d1cc566.png";